import { render, staticRenderFns } from "./PhoneFrame.vue?vue&type=template&id=2d0fbf1e&scoped=true&"
import script from "./PhoneFrame.vue?vue&type=script&lang=js&"
export * from "./PhoneFrame.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFrame.vue?vue&type=style&index=0&id=2d0fbf1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0fbf1e",
  null
  
)

export default component.exports